import React, { useContext, useState } from "react";
import _ from "lodash";
import { Dropdown, DropdownItem, DropdownMenu, Col } from "reactstrap";
import { toast } from "react-toastify";
import { api, constants, dateHelpers, helpers, reportHelpers, UserContext, } from "../utils";

export default function ItemDropdownMenu({customerId = "", ...props}) {
   const userCtx = useContext(UserContext);
   const { customerFilter } = userCtx;
   const isAPU = userCtx.currentUser && (userCtx.currentUser.isAdmin || userCtx.currentUser.isPowerUser);
   const attachmentTypeId = props.attachmentTypeId
      ? props.attachmentTypeId
      : constants.ATTACHMENT_TYPES.Item;

   const [downloading, setDownloading] = useState(false);
   const [open, setOpen] = useState(false);

   function downloadMachineSetupReport() {
      setDownloading(true);
      const payload = {
         ItemNumber: props.itemNumber,
      };
      api
         .postDownloadBinary(
            "Report/MachineSetupItem",
            payload,
            constants.MIME_TYPES.pdf,
            `MSR_${props.itemNumber}_${dateHelpers.getDateStringForReportName()}.pdf`,
            "There was an error downloading the machine setup report"
         )
         .then((res) => {
            if (res?.data === false) {
               toast.error(res.message);
            }
         })
         .catch(api.catchHandler)
         .finally(() => setDownloading(false));
   }

   function downloadSpecReportPdf() {
      setDownloading(true);
      const payload = {
         CustomerId: props.customerId || customerFilter?.value,
         ItemNumber: props.itemNumber,
      };
      api
         .post("Reference/SpecificationExist", payload)
         .then((r) => {
            if (r && r.data && r.data.exist) {
               reportHelpers.downloadSpecReportPdf(props.itemNumber)
            } else {
               toast.info(`No Specification found for Item ${props.itemNumber}`);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error("There was an error downloading the specification report");
         })
         .finally(() => setDownloading(false));
   }

   function getQualityTestXLSX() {
      const startDate = new Date("1-1-1900");
      const endDate = dateHelpers.formatDateForServer(new Date());
      return api
         .postGetBlob("Report/GetQualityTest", {
            SpecNumber: props.itemNumber,
            ItemWithDesc: props.itemDescription,
            StartDate: startDate,
            EndDate: endDate,
         })
         .then((response) => {
            if (response && response.data) {
               const XLS_FILENAME = `Test_Results_${props.itemNumber}_${dateHelpers.toMDYDateString(new Date())}.xlsx`;
               helpers.downloadExport(response.data, XLS_FILENAME, constants.MIME_TYPES.xlsx);
            } else {
               toast.error(response.message || "Error downloading report.");
            }
         })
         .catch(api.catchHandler);
   }

   function replacer(key, value) {
      // Encode # symbol in item string for inventory dashboard link
      if (typeof value === 'string')
         return value.replace(/#/g, '%23');

      return value;
   }

   if (props.custom) {
      return (
         <Col
            // className="data-cell"
            onMouseEnter={() => setOpen(true)}
            onMouseLeave={() => setOpen(false)}
            style={{ position: "relative", verticalAlign: props.alignTop ? 'top' : 'middle' }}
            xs={props.colWidth ?? 2}
         >
            <span className="shredLink fw-bold noWrap">
               {props.itemDescription}
            </span>
            <Dropdown isOpen={open} toggle={() => setOpen(!open)} style={{ position: "absolute", top: "1em", left: "3em" }} >
               <DropdownMenu flip>
                  {isAPU ||
                     userCtx.currentUser?.isEngineerRole ||
                     userCtx.currentUser?.isProductionRole ||
                     userCtx.currentUser?.isInventoryRole ||
                     userCtx.currentUser?.isQualityRole ||
                     userCtx.currentUser?.isPurchasingRole ||
                     userCtx.currentUser?.isSalesperson ||
                     userCtx.currentUser?.isCSRRole ? (
                     <DropdownItem className="sort-handle" >
                        <a rel="noreferrer"
                           href={`/bom-components/search?bomComponent=${JSON.stringify({
                              value: _.trim(props.itemNumber || ""),
                              label: _.trim(props.itemDescription) || _.trim(props.itemNumber || ""),
                           })}`}
                           target="_blank"
                           className="regularAnchor"
                        >
                           Bill of Materials
                        </a>
                     </DropdownItem>
                  ) : null}
                  {isAPU ||
                     userCtx.currentUser?.isMaintenanceRole ||
                     userCtx.currentUser?.isEngineerRole ||
                     userCtx.currentUser?.isProductionRole ? (
                     <DropdownItem className="sort-handle" onClick={downloadMachineSetupReport} disabled={downloading} >
                        Print Machine Setup Report
                     </DropdownItem>
                  ) : null}
                  {isAPU ||
                     userCtx.currentUser?.isCSRRole ||
                     userCtx.isEngineerRole ||
                     userCtx.currentUser?.isInventoryRole ||
                     userCtx.currentUser?.isProductionRole ||
                     userCtx.currentUser?.isPurchasingEdit ||
                     userCtx.currentUser?.isQualityEdit ||
                     userCtx.currentUser?.isSalesEdit ||
                     userCtx.currentUser?.isSewingTech ||
                     userCtx.currentUser?.isWarehouseRole ? (
                     <DropdownItem
                        className="sort-handle"
                        onClick={() => reportHelpers.getCaseLotInventoryReport(props.itemNumber)}
                        disabled={downloading}
                     >
                        Print Case Lot Report
                     </DropdownItem>
                  ) : null}
                  {isAPU ||
                     userCtx.currentUser?.isCSRRole ||
                     userCtx.currentUser?.isEngineerRole ||
                     userCtx.currentUser?.isQualityRole ||
                     userCtx.currentUser?.isSalesperson ? (
                     <DropdownItem className="sort-handle" onClick={downloadSpecReportPdf} disabled={downloading} >
                        Print Specification Report
                     </DropdownItem>
                  ) : null}
                  {isAPU ||
                     userCtx.currentUser?.isEngineerRole ||
                     userCtx.currentUser?.isQualityRole ||
                     userCtx.currentUser?.isSalesperson ? (
                     <DropdownItem onClick={getQualityTestXLSX}>
                        Print Quality Tests
                     </DropdownItem>
                  ) : null}
                  {isAPU ||
                     userCtx.currentUser?.isCSRRole ||
                     userCtx.currentUser?.isEngineerRole ||
                     userCtx.currentUser?.isInventoryRole ||
                     userCtx.currentUser?.isProductionRole ||
                     userCtx.currentUser?.isPurchasingRole ||
                     userCtx.currentUser?.isQualityRole ||
                     userCtx.currentUser?.isSalesperson ||
                     userCtx.currentUser?.isWarehouseRole ? (
                     <DropdownItem className="sort-handle">
                        <a rel="noreferrer"
                           href={`/inventoryDashboard/${JSON.stringify({
                              value: _.trim(props.itemNumber || ""),
                              itemNumber: _.trim(props.itemNumber || ""),
                              label: _.trim(props.itemDescription || _.trim(props.itemNumber || "")),
                           }, replacer)}`}
                           target="_blank"
                           className="regularAnchor"
                        >
                           Inventory Dashboard
                        </a>
                     </DropdownItem>
                  ) : null}
                  {isAPU ||
                     userCtx.currentUser?.isMaintenanceRole ||
                     userCtx.currentUser?.isEngineerRole ||
                     userCtx.currentUser?.isProductionRole ? (
                     <DropdownItem className="sort-handle">
                        <a rel="noreferrer"
                           className="text-link"
                           href={`/pph-calculator/${JSON.stringify({
                              value: props.itemNumber,
                              label: props.itemDescription,
                           })}`}
                           target="_blank"
                        >
                           View PPH Calculator
                        </a>
                     </DropdownItem>
                  ) : null}
                  <DropdownItem className="sort-handle">
                     <a rel="noreferrer"
                        href={`/attachments/${attachmentTypeId}/${props.itemNumber}`}
                        target="_blank"
                        className="regularAnchor"
                     >
                        Attachments{" "}
                        {props.attachmentCount > -1
                           ? `(${props.attachmentCount})`
                           : null}
                     </a>
                  </DropdownItem>
               </DropdownMenu>
            </Dropdown>
         </Col>
      );
   } else {
      return (
         <td
            className="data-cell"
            onMouseEnter={() => setOpen(true)}
            onMouseLeave={() => setOpen(false)}
            style={{ position: "relative", verticalAlign: props.alignTop ? 'top' : 'middle' }}
         >
            <span className="shredLink fw-bold noWrap">
               {props.itemDescription}
            </span>
            <Dropdown isOpen={open} toggle={() => setOpen(!open)} style={{ position: "absolute", top: "2em", left: "3em" }} >
               <DropdownMenu flip>
                  {isAPU ||
                     userCtx.currentUser?.isEngineerRole ||
                     userCtx.currentUser?.isProductionRole ||
                     userCtx.currentUser?.isInventoryRole ||
                     userCtx.currentUser?.isQualityRole ||
                     userCtx.currentUser?.isPurchasingRole ||
                     userCtx.currentUser?.isSalesperson ||
                     userCtx.currentUser?.isCSRRole ? (
                     <DropdownItem className="sort-handle" >
                        <a rel="noreferrer"
                           href={`/bom-components/search?bomComponent=${JSON.stringify({
                              value: _.trim(props.itemNumber || ""),
                              label: _.trim(props.itemDescription) || _.trim(props.itemNumber || ""),
                           })}`}
                           target="_blank"
                           className="regularAnchor"
                        >
                           Bill of Materials
                        </a>
                     </DropdownItem>
                  ) : null}
                  {isAPU ||
                     userCtx.currentUser?.isMaintenanceRole ||
                     userCtx.currentUser?.isEngineerRole ||
                     userCtx.currentUser?.isProductionRole ? (
                     <DropdownItem
                        className="sort-handle"
                        onClick={downloadMachineSetupReport}
                        disabled={downloading}
                     >
                        Print Machine Setup Report
                     </DropdownItem>
                  ) : null}
                  {isAPU ||
                     userCtx.currentUser?.isCSRRole ||
                     userCtx.isEngineerRole ||
                     userCtx.currentUser?.isInventoryRole ||
                     userCtx.currentUser?.isProductionRole ||
                     userCtx.currentUser?.isPurchasingEdit ||
                     userCtx.currentUser?.isQualityEdit ||
                     userCtx.currentUser?.isSalesEdit ||
                     userCtx.currentUser?.isSewingTech ||
                     userCtx.currentUser?.isWarehouseRole ? (
                     <DropdownItem
                        className="sort-handle"
                        onClick={() => reportHelpers.getCaseLotInventoryReport(props.itemNumber)}
                        disabled={downloading}
                     >
                        Print Case Lot Report
                     </DropdownItem>
                  ) : null}
                  {isAPU ||
                     userCtx.currentUser?.isCSRRole ||
                     userCtx.currentUser?.isEngineerRole ||
                     userCtx.currentUser?.isQualityRole ||
                     userCtx.currentUser?.isSalesperson ? (
                     <DropdownItem className="sort-handle" onClick={downloadSpecReportPdf} disabled={downloading} >
                        Print Specification Report
                     </DropdownItem>
                  ) : null}
                  {isAPU ||
                     userCtx.currentUser?.isEngineerRole ||
                     userCtx.currentUser?.isQualityRole ||
                     userCtx.currentUser?.isSalesperson ? (
                     <DropdownItem onClick={getQualityTestXLSX}>
                        Print Quality Tests
                     </DropdownItem>
                  ) : null}
                  {isAPU ||
                     userCtx.currentUser?.isCSRRole ||
                     userCtx.currentUser?.isEngineerRole ||
                     userCtx.currentUser?.isInventoryRole ||
                     userCtx.currentUser?.isProductionRole ||
                     userCtx.currentUser?.isPurchasingRole ||
                     userCtx.currentUser?.isQualityRole ||
                     userCtx.currentUser?.isSalesperson ||
                     userCtx.currentUser?.isWarehouseRole ? (
                     <DropdownItem className="sort-handle">
                        <a rel="noreferrer"
                           href={`/inventoryDashboard/${JSON.stringify({
                              value: _.trim(props.itemNumber || ""),
                              itemNumber: _.trim(props.itemNumber || ""),
                              label: _.trim(props.itemDescription || _.trim(props.itemNumber || "")),
                           }, replacer)}`}
                           target="_blank"
                           className="regularAnchor"
                        >
                           Inventory Dashboard
                        </a>
                     </DropdownItem>
                  ) : null}
                  {isAPU ||
                     userCtx.currentUser?.isMaintenanceRole ||
                     userCtx.currentUser?.isEngineerRole ||
                     userCtx.currentUser?.isProductionRole ? (
                     <DropdownItem className="sort-handle">
                        <a rel="noreferrer"
                           className="text-link"
                           href={`/pph-calculator/${JSON.stringify({
                              value: props.itemNumber,
                              label: props.itemDescription,
                           })}`}
                           target="_blank"
                        >
                           View PPH Calculator
                        </a>
                     </DropdownItem>
                  ) : null}
                  <DropdownItem className="sort-handle">
                     <a rel="noreferrer"
                        href={`/attachments/${attachmentTypeId}/${props.itemNumber}`}
                        target="_blank"
                        className="regularAnchor"
                     >
                        Attachments{" "}
                        {props.attachmentCount > -1
                           ? `(${props.attachmentCount})`
                           : null}
                     </a>
                  </DropdownItem>
               </DropdownMenu>
            </Dropdown>
         </td>
      );
   }
}

// ItemDropdownMenu.defaultProps = {
//    customerId: "",
// };
